import { BaseApiService } from 'services/BaseApiService';
import { ICurrency } from 'models/ICurrency';

class CurrencyApiService extends BaseApiService {
	public getAllCurrency = () =>
		this.get<ICurrency[]>(`/Currency/get-all-currencies`);
}

export default new CurrencyApiService();
